import { PrintBarcodeApiResponse, PrintBarcodeClient } from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from 'business/services/BaseService';

export default class PrintingService extends BaseService {
  async printExperimentInformation(plateId: number): Promise<PrintBarcodeApiResponse> {
    const client: PrintBarcodeClient = ModelFactory(PrintBarcodeClient, false, true);
    return client.performExperimentInformationPrinting(plateId);
  }
}
